export default function dataReducer(state = {}, action) {
  const { data } = action;
  return data && Object.keys(data).length ? data : state;
}
